import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button/Button';
import Typography from '@mui/material/Typography/Typography';

import { colors } from 'styles/colors';
import { devices } from 'styles';
import Box from '@mui/material/Box/Box';

export const Wrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 48px 32px 156px;
  width: 100%;

  @media (${devices.sm}) {
    padding: 48px 32px 188px;
  }

  @media (${devices.lg}) {
    padding: 160px 0 196px;
  }
`;

const WebImage = styled('img')`
  display: none;
  position: absolute;

  @media (${devices.md}) {
    display: block;
  }
`;

export const WebLeft = styled(WebImage)`
  left: -70px;
  top: 15px;
  width: 392px;
  height: 696px;
`;

export const WebRight = styled(WebImage)`
  right: -70px;
  top: 25px;
  top: 0;
  width: 428px;
  height: 655px;
`;

export const HeroTitle = styled(Typography)`
  font-weight: 700;
  font-size: 40px;
  line-height: 120%;
  color: ${colors.white};
  text-align: center;
  max-width: 768px;

  @media (${devices.md}) {
    font-size: 56px;
  }
`;

export const HeroDescription = styled(Typography)`
  font-size: 16px;
  line-height: 150%;
  color: ${colors.white};
  text-align: center;
  margin: 24px 0px 32px 0px;
  max-width: 700px;
`;

export const ExploreCustomerCaseButton = styled(Button)`
  padding: 12px 24px;
  color: ${colors.white};
  background-color: ${colors.mainDark};
  border: 1px solid ${colors.white};
  font-size: 16px;
  line-height: 150%;
  text-transform: none;
  border-radius: 0;
  width: 240px;

  :hover {
    background-color: ${colors.white};
    border: 1px solid ${colors.mainDark};
    color: ${colors.mainDark};
  }

  @media (${devices.xs}) {
    width: auto;
  }
`;

export const ButtonsWrapper = styled(Box)`
  display: flex;
  justify-content: inherit;
  align-items: center;
  flex-direction: column;

  @media (${devices.sm}) {
    flex-direction: row;
    justify-content: center;
    flex-direction: row;
    align-items: inherit;
  }
`;

export const BlueButtonWrapper = styled(Box)`
  width: 100%;
  margin-right: 0;

  @media (${devices.sm}) {
    width: auto;
  }
`;
